import React, { useEffect } from "react";
import "./FundCard.scss";
import {
  createOrderItems,
  getCartToken,
  updateCart,
} from "../services/cart.service";
import useToast from "../hooks/useToast";
import {
  getWebformToken,
  setHonoreePresets,
  setJointGiftPresets,
  setPledgePresets,
  setCampaignPath,
  setCampaignFundSelected,
} from "../services/funds.service";
import { useAppContext } from "../hooks/useAppContext";
import { getWithExpiry, setWithExpiry } from "../helpers/localStorageExpiry";

export default function FundCard({
  fundUUID,
  frequency,
  fundTitle,
  fundDescription,
  hideHonoree,
  honoree,
  hidePledge,
  isPledge,
  hideJointGift,
}) {
  const { items, cart } = useAppContext();
  const [itemIds, setItemIds] = React.useState([]);
  const buttonRef = React.useRef(null);

  useEffect(() => {
    let ids = [];
    items.map((v, i) => {
      ids.push(v.relationships.purchased_entity.data.id);
    });
    setItemIds(ids);
  }, [items]);

  function getNotificationError(id, action, message) {
    return useToast({
      type: "error",
      id,
      actionText: "RETRY?",
      action: async () => await action(),
      dismissable: true,
      message,
    });
  }

  function addFundToCart(fundUUID, webformToken) {
    const notifyCreateOrderItemError = (err) =>
      getNotificationError(
        "createOrderItems",
        () => addFundToCart(fundUUID),
        `There was a problem adding the fund to your cart. ${err.toString()}`
      );
    return createOrderItems({
      amt: "0.00",
      fund_id: fundUUID,
      freq: frequency,
      webform_token: webformToken,
      category: location.pathname,
    })
      .then((response) => {
        setHonoreePresets(hideHonoree, honoree);
        setPledgePresets(hidePledge, isPledge);
        setJointGiftPresets(hideJointGift);
        setCampaignPath(window.location.pathname);
        getCartToken();
        location.href = "/give/checkout";
      })
      .catch((err) => {
        notifyCreateOrderItemError(err);
      });
  }

  function onClickDonate(fundUUID, added) {
    setCampaignFundSelected(fundUUID);
    const webformToken = getWebformToken();
    const submitButton = document.getElementsByClassName(
      "webform-button--submit"
    )[0];
    if (submitButton) {
      let e = document.createEvent("MouseEvents");
      e.initMouseEvent(
        "mousedown",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      submitButton.dispatchEvent(e);
      return;
    }
    if (webformToken && !added) {
      buttonRef.current.disabled = true;
      return addFundToCart(fundUUID, webformToken);
    }
    // Update the token if the fund has been added but we don't have a submission.
    buttonRef.current.disabled = true;
    return updateCart(cart.id, { field_webform_token: webformToken }).then(
      () => {
        setHonoreePresets(hideHonoree, honoree);
        setPledgePresets(hidePledge, isPledge);
        setJointGiftPresets(hideJointGift);
        setCampaignPath(window.location.pathname);
        location.replace("/give/checkout");
      }
    );
  }

  return (
    <div key={fundUUID} className="fund-card">
      <div className="fund-card__inner">
        <h2
          className={`fund-card__title${
            fundDescription && " has-large-description"
          }`}
        >
          {fundTitle}
        </h2>
        {fundDescription && (
          <div className="fund-card__description">{fundDescription}</div>
        )}
        <div className="fund-card__actions">
          {itemIds.indexOf(fundUUID) !== -1 ? (
            <button
              ref={buttonRef}
              className="fund-card__button is-in-cart coh-style-link-button-with-icon"
              onClick={(event) => onClickDonate(fundUUID, true)}
            >
              Added
            </button>
          ) : (
            <button
              ref={buttonRef}
              data-hook="donate-btn"
              className="fund-card__button coh-style-link-button-with-icon"
              onClick={(event) => onClickDonate(fundUUID, false)}
            >
              Give now
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
